import { render } from "./Donut.vue?vue&type=template&id=4675e865&scoped=true&ts=true"
import script from "./Donut.vue?vue&type=script&lang=ts"
export * from "./Donut.vue?vue&type=script&lang=ts"

import "./Donut.vue?vue&type=style&index=0&id=4675e865&lang=css"
import "./Donut.vue?vue&type=style&index=1&id=4675e865&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4675e865"]])

export default __exports__